
    <a [title]="text.import" class="button import-bcf-button" (click)="handleClick()">
      <op-icon icon-classes="button--icon icon-import"></op-icon>
      <span class="button--text"> {{text.import}} </span>
    </a>
  